import { render } from "./AdminEquipmentGrid.vue?vue&type=template&id=4fec8be0"
import script from "./AdminEquipmentGrid.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminEquipmentGrid.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script